// extracted by mini-css-extract-plugin
export default {"cls1":"Or1bshIgyHUEakT6P4rv","cls2":"ZX6X7JSKrYm_YgC6HrsN Or1bshIgyHUEakT6P4rv","isTabletDown":"ND2FvWN2oWyC4VRmTGr_","isPhone":"ROeEsqdXCiZQl_D6OjYQ"};